/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Step_Track_Job_DescInputs */

const en_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save a job posting`)
};

const de_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichere eine Stellenanzeige`)
};

const fr_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistre une offre d'emploi`)
};

const es_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarde una oferta de empleo`)
};

const it_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva un'offerta di lavoro`)
};

const nl_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewaar een vacature`)
};

const pl_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz ogłoszenie o pracę`)
};

const fi_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallenna työpaikkailmoitus`)
};

const da_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gem et jobopslag`)
};

const sv_dashboard_step_track_job_desc = /** @type {(inputs: Dashboard_Step_Track_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spara en jobbannons`)
};

/**
* | output |
* | --- |
* | "Save a job posting" |
*
* @param {Dashboard_Step_Track_Job_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_step_track_job_desc = /** @type {((inputs?: Dashboard_Step_Track_Job_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Step_Track_Job_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_step_track_job_desc(inputs)
	if (locale === "fr") return fr_dashboard_step_track_job_desc(inputs)
	if (locale === "es") return es_dashboard_step_track_job_desc(inputs)
	if (locale === "it") return it_dashboard_step_track_job_desc(inputs)
	if (locale === "nl") return nl_dashboard_step_track_job_desc(inputs)
	if (locale === "pl") return pl_dashboard_step_track_job_desc(inputs)
	if (locale === "fi") return fi_dashboard_step_track_job_desc(inputs)
	if (locale === "da") return da_dashboard_step_track_job_desc(inputs)
	if (locale === "sv") return sv_dashboard_step_track_job_desc(inputs)
	return en_dashboard_step_track_job_desc(inputs)
});